export const PERMISSIONS = {
    VIEW_HOME: 'view_home',
    VIEW_SCHEDULE: 'view_schedule',
    VIEW_CASES: 'view_cases',
    VIEW_CAR_CASES: 'view_car_cases',
    VIEW_BILLINGS: 'view_billings',
    VIEW_ACCOUNT: 'view_account',
    VIEW_APPOINTMENTS: 'view_appointments',
    VIEW_CRM: 'view_crm',
}

export const ALL_PERMISSIONS = Object.values(PERMISSIONS)

export const CAR_PORTAL_MINIMAL_PERMISSIONS = [
    // PERMISSIONS.VIEW_HOME,
    PERMISSIONS.VIEW_CAR_CASES,
    PERMISSIONS.VIEW_ACCOUNT,
]
